var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.composition.details))]),_vm._l((_vm.composition.asterisks),function(text,i){return _c('p',{key:i},[_vm._v(_vm._s(text))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }